import React, {Component} from 'react'
import Footer from "../Footer/Footer"
import Slider from "../SliderSection/Slider"
import BoxsSection from "../BoxsSection/BoxsSection"
import AboutRight from "../AboutRight/AboutRight"
import AboutLeft from "../AboutLeft/AboutLeft"
import ServicesRight from "../ServicesRight/ServicesRight"
import ServicesLeft from "../ServicesLeft/ServicesLeft"
// import MenuAppBar from "../MenuAppBar/MenuAppBar"
import Clients from "../Clients/Clients"
import About from "../About";
import Slider2 from "../slide2";
// import ImgEnecolor from "../../../public/img/bg_enecolor.PNG";
import {Hidden, withStyles} from '@material-ui/core'
import MainLogo from "../MainLogo";
import FontW5 from "../Font/FontW5";
// import { isMobileOnly } from "react-device-detect";

const style = theme => ({
   root: {
      [theme.breakpoints.up('sm')]: {
         marginRight: 30,
         marginLeft: 30,
         marginTop: 30,
      },
   },
   setMargin1: {

      backgroundPosition: 'left',
      maxWidth: '770px',
      ['@media (min-width:960px)']: {
         marginLeft: -238,
      },
      ['@media (min-width:992px)']: {
         marginRight: 0,
         marginLeft: -229,
      },
      ['@media (min-width:1200px)']: {
         marginRight: 'auto',
         marginLeft: -185,
      },
      [theme.breakpoints.down('sm')]: {
         backgroundPosition: 'center',
      },
   },
   setMargin2:{
      maxWidth: 500,
      marginRight: 'auto',
      marginTop: 30,
      marginBottom: 30,
      ['@media (min-width:992px)']: {
         marginLeft: -30,
      },
      ['@media (min-width:1200px)']: {
         marginLeft: 87,
      },
      [theme.breakpoints.down('md')]: {
         backgroundPosition: 'center',
      },
   },
   setMargin3:{
      marginRight: -35,
      [theme.breakpoints.down('sm')]: {
         margin: '5px 0',
         backgroundPosition: 'center',
      },
   },
    topImg: {
        width: '80%',
        maxWidth: '80vh',
        margin: 'auto',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            maxWidth: '90vh',
        }
    },
    paddingTop: {
       paddingTop: 70,
       [theme.breakpoints.down('sm')]: {
          paddingTop: 5,
       },
    },
    // butterFlyText: {
    //     marginTop: isMobileOnly ? 0 : 135,
    //     marginBottom: isMobileOnly ? 0 : -35,
    //     [theme.breakpoints.down('sm')]: {
    //         marginTop: 0,
    //         marginBottom: 0
    //     },
    // },
   marginBox: {
      marginTop: -30,
      [theme.breakpoints.down('xs')]: {
         marginTop: 0,
      }
   }
})

class WhoAmI extends Component {
    render() {
       const {classes,match} = this.props
        if (match.url=== '/whoami/'){
            window.location.assign('/whoami')
        }

        return (
            <div className={classes.root}>
                <div id="preloader">
                    <div className="pre-container">
                        <div className="logo-circle">Geniam</div>
                    </div>
                </div>
                <Hidden xsDown>
                    <span className="frame-line top-frame"/>
                    <span className="frame-line right-frame"/>
                    <span className="frame-line bottom-frame"/>
                    <span className="frame-line left-frame"/>
                </Hidden>
                <MainLogo title={"Identary Work School"}/>
                {/*<div*/}
                {/*   data-scroll-index="0"*/}
                {/*   style={{*/}
                {/*      width:'100%',height:'100vh',*/}
                {/*      textAlign: 'center',*/}
                {/*      display:'flex',*/}
                {/*      backgroundColor: '#FFF',*/}
                {/*   }}*/}
                {/*>*/}
                {/*    <img*/}
                {/*       src="img/slide/top.png"*/}
                {/*       alt="top"*/}
                {/*       className={classes.topImg}*/}
                {/*    />*/}
                {/*</div>*/}
                <div data-scroll-index="0">
                    <Slider
                        content={
                            <>
                                1,「私を、どう見ているか？」から、全てが始まっている。<br/>
                                2,「アイデンティティ・シフト」と「自己強化サイクル」<br/>
                                3,「Enecolorの感情特性」と「関係性」<br/>
                                4,「感情」と「感覚」と「呼吸」の連動<br/>
                                5,「呼吸の開放」と「声色」と「プレゼン力」<br/>
                                6,「呼吸力」で「内観力」と「感情伝達力」を高める<br/>
                                7,「心とは？」「感情とは？」を図解した内面モデル<br/>
                                8,「メタ認知力」を高め「在り方を選択」する技術<br/>
                                9,「ポジティブの罠」を脱し「天才性を発揮」するには？<br/>
                                10,「行動力が発揮できない時」の深層心理<br/>
                                11,「高次目的」と「統合」をもたらす問いの技術<br/>
                                12,「Visionの統合」と「第3の道」の開き方<br/>
                                13,「統合された高次目的」を具現化するには？<br/>
                                14,「自己統合」と「自己実現」の「内なる全体地図」<br/>
                                15,「抽象的な価値」を、「具体的な事業」へ<br/>
                                16,「自分の軸ど真ん中」の仕事を作るには？<br/>
                                17,「自己開放」から「究極のフォーカス」を定める。<br/>
                            </>
                        }
                    />
                </div>


                <BoxsSection setMargin={classes.marginBox}/>
                <AboutLeft
                    img={'img/sau.png'}
                    title={'自己成長の20-30代「がむしゃら期」'}
                    content={
                        <>
                            20代は「仕事力」を磨き、30代は「強み」を磨いてきた。限界に挑戦したり、苦難を仲間と乗り越えたり、今思えばあっと言う間だった気がする。<br/><br/>
                            そして、それなりの自己実現はしてきた。そして、今踊り場に立っている。どうせ、次に挑戦するならば、できれば人生を懸けられるほどの、心底「これこそが、自分の道だ」と思える仕事をしたい。
                        </>
                    }
                />
                <AboutRight
                    img={'img/AdobeStock_168596986.png'}
                    title={'次の10年のための「黄金のサナギ期」'}
                    content={
                        <>
                            若い時のように、ただがむしゃらに頑張るのはなんか違う。かと言って、ただ自己探求だけするのも違う気がする。なにかこう自分の核心から溢れ出すものを形にしたい。
                            <br/>
                            <br/>
                            オオゴマダラのサナギは黄金色に輝いている。今がまさに、大人になったからこその、真に自分を見つめ直し、深める黄金のサナギのような時期かもしれない。
                        </>
                    }
                    setMargin={classes.setMargin1}
                />
                <AboutLeft
                    img={'img/butterfly.png'}
                    title={
                        <>
                            「統合された自己」として羽ばたく。
                        </>
                    }
                    content={
                        <>
                            内なる多様化した自己を、深く扱っていくと、どうも「統合」という概念に行き着く。実は、全ての内なる自己には存在意義があり、その目的は一点に集約されていくようなのだ。
                            <br/><br/>
                            そして、人生を通じて育まれてきた「陰も陽もある自己」が統合されていき、自己一致の確信がある「真我」とも言える自己へと集約された。
                            <br/><br/>
                            そして、この真我としての自己実現が、いま始ろうとしている。
                        </>
                    }
                    marginOnTop={-70}
                    setMargin={classes.setMargin3}
                    paddingTop={classes.paddingTop}
                />
                <AboutRight
                    img={'img/life.png'}
                    title={'ど真ん中を生き、ど真ん中を活かす。'}
                    content={
                        <>
                            この無料オンライン講座「Who am I?」は、「統合的な自己」を練り上げる「アイデンティティの学校」であるアイダモンの講座から、講義映像を抜粋して作られています。経営者や、著者、ビジネスリーダーが1年半の間に360人も参加してくださったスクールです。「アイデンタリーに生きる。」をコンセプトに、真の自己から始まる、生き方、働き方を開拓していきます。
                        </>
                    }
                    titleSignature={'Identary Work School'}
                    signature={
                        <>
                            アイダモン
                            <div className="mt-30">
                                <FontW5 className="font-16px">
                                    ※identaryは、「Identityをベースにしている」という意味の造語
                                </FontW5>
                            </div>
                        </>
                    }
                    setMargin={classes.setMargin2}
                    setbgColor={'#F5F5F5 !important'}
                    setHeightImg={480}
                />
                <ServicesRight
                    img={'img/service.svg'}
                    title={'エネルギー特性を知る。'}
                    content={
                        `「エネカラー®」は、80万人が利用した自己特色を診断する理論です。性格や強みの特性が分かるだけでなく、身体感覚や呼吸、声とも連動しています。そのため、知識だけではなく、コミュニケーション力や人間関係力向上のために、実践的にトレーングできることが特徴です。`
                    }
                    backgroundImage={'img/bg_enecolor2.png'}
                    borderColor={'#FE8502'}
                />
                <ServicesLeft
                    img={'img/service2_Zipsize.svg'}
                    title={'バイアスをひも解く。'}
                    content={`
                    「インサイト・マップ®」は、深層心理を可視化し、社会を俯瞰できるツールです。「内面の葛藤」と「社会の矛盾」を紐解き、統合的なソリューションを導くことができるツールです。10年以上も葛藤してきたテーマでも、90分前後でひも解けてしまうため、意思決定への時間対効果が非常に高いことが特徴です。
                    `}
                    backgroundImage={'img/bg_insightmap3.jpg'}
                    borderColor={'#554773'}
                    bgRepeat={'repeat-y'}
                    bgPosition={true}
                    bgSize={true}
                />
                <ServicesRight
                    img={'img/service_3.svg'}
                    title={'陰陽の自己を統合する。'}
                    content={
                        `「インナー・グローブ™」は、数千回の個別セッションを通じて、抽象的で複雑な人の「内的世界をマッピング」するために開発された理論です。内なる自己を統合する過程を全て「内なる地図」として生成できるため、複雑な概念でも迷子にならず、内的世界を旅することができます。`
                    }
                    backgroundImage={'img/bg_innerGlobe2.png'}
                    borderColor={'#62AEC0'}
                />
                <ServicesLeft
                    img={'img/service_4.svg'}
                    title={'自己と社会を統合する。'}
                    content={
                        `「アイデンティティ・コンパス™」は、「何者として、どこへ向かうか？」という、「アイデンティティとヴィジョン」の関係と、「何のために、どんな役割を担うのか？」という、「ゴールとパート」の関係を理解するための概念です。この2つのベクトルが揃った時、私達は、一貫性を持って力を発揮できるのです。`
                    }
                    backgroundImage={'img/bg_indentity3.png'}
                    borderColor={'#609831'}
                />
                <About
                    img={'img/ikuta.png'}
                    title={'人類の進化を加速したい発明家'}
                />
                <Clients/>
                <Slider2
                   content={
                      <>
                         1,「私を、どう見ているか？」から、全てが始まっている。<br/>
                         2,「アイデンティティ・シフト」と「自己強化サイクル」<br/>
                         3,「Enecolorの感情特性」と「関係性」<br/>
                         4,「感情」と「感覚」と「呼吸」の連動<br/>
                         5,「呼吸の開放」と「声色」と「プレゼン力」<br/>
                         6,「呼吸力」で「内観力」と「感情伝達力」を高める<br/>
                         7,「心とは？」「感情とは？」を図解した内面モデル<br/>
                         8,「メタ認知力」を高め「在り方を選択」する技術<br/>
                         9,「ポジティブの罠」を脱し「天才性を発揮」するには？<br/>
                         10,「行動力が発揮できない時」の深層心理<br/>
                         11,「高次目的」と「統合」をもたらす問いの技術<br/>
                         12,「Visionの統合」と「第3の道」の開き方<br/>
                         13,「統合された高次目的」を具現化するには？<br/>
                         14,「自己統合」と「自己実現」の「内なる全体地図」<br/>
                         15,「抽象的な価値」を、「具体的な事業」へ<br/>
                         16,「自分の軸ど真ん中」の仕事を作るには？<br/>
                         17,「自己開放」から「究極のフォーカス」を定める。<br/>
                      </>
                   }
                />
                <BoxsSection/>
                <Footer/>

                {/*<MenuAppBar/>*/}
            </div>
        );
    }
}

export default withStyles(style)(WhoAmI)
